import { ContextProvider } from "./Context/Context";
import Router from "./Routes/Router";
import { Provider } from 'react-redux';

import store from './Firebase/store';

// note: cursos
// note: hay 8 tipos de cursos los cuales son los siguentes:
// 1 => artes visuales
// 2 => Fotografía e imagen
// 3 => multimedia e internet
// 4 => video y cine
// 5 => diseño y publicidad
// 6 => animacion y comic
// 7 => escritura y guion
// 8 => audio y Radio

// note: hay 4 tipos de modalidades
//  1 => presencial
//  2 => hibrido
//  3 => videorreunion
//  4 => google classroom

// note: hay 3 tipos de formatos
//  1 => talleres
//  2 => cursos
//  3 => diplomados

function App() {
  return (
    <Provider store={store}>
      <ContextProvider>
        <Router/>
      </ContextProvider>
    </Provider>
  );
}

export default App;
